<template>
	<span class="w5-question-block" :class="{ 'small': small }">
		<span @click="ShowAnswer" class="w5-question" :ref="'w5-question-block-' + Index">?</span>
	</span>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Notice',
	//=========================================================================
	// свойства, задаются только родителем
	//=========================================================================
	props: ['text', 'small', 'index'],
	//=========================================================================
	// локальные свойства
	//=========================================================================
	data() {
		return {
			answerVisible: false,
			Index: 'first',
			answerBlock: null
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		if (this.index) this.Index = this.index
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('scroll', this.scrollHandler)
		document.addEventListener('mousedown', this.clickHandler)

		this.answerBlock = document.createElement('div')
		this.answerBlock.className = 'w5-question-answer'
		this.answerBlock.innerHTML = this.text

		let _close = document.createElement('span')
		_close.className = 'close'
		_close.title = this.localeFtc('main/close')
		_close.innerHTML = '×'

		this.answerBlock.insertBefore(_close, this.answerBlock.firstChild)
		document.body.appendChild(this.answerBlock)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('scroll', this.scrollHandler)
		document.removeEventListener('mousedown', this.clickHandler)
		document.body.removeChild(this.answerBlock)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// открытие
		//---------------------------------------------------------------------
		ShowAnswer() {
			// расчитаем положение
			let _el = this.$refs['w5-question-block-' + this.Index]
			let _coord = this.getElementOffset(_el, true)
			let _left = _coord.left - 150
			// границы
			if (_left < 20) _left = 20
			if (_left > this.$store.state.windowWidth - 300 - 20) _left = this.$store.state.windowWidth - 300 - 20

			// покажем
			this.setStyle({
				'top': (_coord.top - 20) + 'px',
				'left': _left + 'px',
				'display': 'inline-block'
			})
			this.answerVisible = true
		},
		//---------------------------------------------------------------------
		// закрытие
		//---------------------------------------------------------------------
		Hide() {
			if (!this.answerVisible) return
			this.setStyle({
				'display': 'none'
			})
			this.answerVisible = false
		},
		//---------------------------------------------------------------------
		// событие: клик мышкой
		//---------------------------------------------------------------------
		clickHandler(e) {
			this.Hide()
		},
		//---------------------------------------------------------------------
		// событие: нажата клавиша на всем документе
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие всех диалогов по ESC
			if (e.keyCode === 27)
				this.Hide()
		},
		//---------------------------------------------------------------------
		// событие: скролл документа
		//---------------------------------------------------------------------
		scrollHandler(e) {
			this.Hide()
		},
		//---------------------------------------------------------------------
		// функция устанавливает аттрибуты нашему блоку
		//---------------------------------------------------------------------
		setStyle(props) {
			for (let _prop in props)
				this.answerBlock.style[_prop] = props[_prop]
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-question-block {
	position: relative;
}

.w5-question {
	display: inline-block;
	height: 20px;
	line-height: 20px;
	width: 20px;
	text-align: center;
	border: 1px solid #ccc;
	border-radius: 10px;
	font-weight: 500;
	font-size: 13px;
	color: #ccc;
	transition: all 0.2s;
	cursor: pointer;
	user-select: none;
}

.w5-question-block.small > .w5-question {
	height: 16px;
	line-height: 16px;
	width: 16px;
	border-radius: 8px;
	font-size: 10px;
}

.w5-question:hover {
	border-color: #333;
	color: #333;
}

.w5-question-answer {
	position: fixed;
	display: none;
	width: 300px;
	height: 60px;
	background-color: #fcfcfc;
	border: 1px solid #ddd;
	border-radius: 4px;
	z-index: 9999;
	padding: 10px;
	font-size: 13px;
	color: #000;
	user-select: none;
}

.w5-question-answer > span.close {
	position: relative;
	top: -10px;
	right: -5px;
}

@media (max-width: 767px) {
	.w5-question-answer {
		top: -40px;
		left: -5px;
	}
}

</style>



// WEBPACK FOOTER //
// notice.vue?152f3954